// Shapes
import { CompanyShape } from "~shapes/company"

export const isCompanyActive = (company: CompanyShape): boolean => {
  return company.status.toLowerCase() === "active"
}
